import { render, staticRenderFns } from "./ClanReminder.vue?vue&type=template&id=6a376b76&"
import script from "./ClanReminder.vue?vue&type=script&lang=js&"
export * from "./ClanReminder.vue?vue&type=script&lang=js&"
import style0 from "./ClanReminder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports